import { useT } from '../../i18n';
import { useNow } from '../../hooks/useMedia';
import { startOfDay } from '../../lib/dates';
import { useCards } from '../../store/cards';
import { useSettings } from '../../store/settings';
import { useUi } from '../../store/ui';
import controls from '../controls.module.css';
import { Cross } from '../icons';
import styles from './Levers.module.css';

/** The one dreaded thing picked for today, kept in sight until midnight or Done. */
export function PinnedBar() {
  const t = useT();
  const now = useNow();
  const pinned = useSettings((s) => s.pinnedToday);
  const set = useSettings((s) => s.set);
  const card = useCards((s) => (pinned ? s.cards[pinned.cardId] : undefined));
  const openSheet = useUi((s) => s.openSheet);
  if (!pinned || !card || pinned.day !== startOfDay(now) || card.status !== 'open' || card.deletedAt !== null) return null;
  return (
    <div className={`${styles.bar} ${styles.pinned}`} role="status" data-pinned="">
      <button type="button" className={styles.text} onClick={() => openSheet(card.id)}>
        <span className={styles.lead}>{t.t('pinned.lead')}</span>
        <span className={styles.title}>{card.title}</span>
      </button>
      <button type="button" className={controls.iconbtn} onClick={() => void set('pinnedToday', null)} aria-label={t.t('pinned.unpin')} title={t.t('pinned.unpin')}>
        <Cross size={18} />
      </button>
    </div>
  );
}
